import * as routes from '../routes';

export const landing = {
  label: 'Home',
  route: routes.landingRoute,
};

export const statisticsLanding = {
  label: 'Home',
  route: routes.statisticsLandingRoute,
};

export const helpDeskDashboard = {
  label: 'Dashboard',
  route: routes.supportDashboardRoute,
};

/* User menu */
export const cedap = {
  label: 'CeDAP',
  subMenu: [
    {
      label: 'Dashboard',
      route: routes.cedapDashboardRoute,
    },
    {
      label: 'CeDAP',
      route: routes.cedapManageRoute,
    },
    {
      label: 'Validazione',
      route: routes.cedapValidationRoute,
    },
    {
      label: 'Attestato di nascita',
      route: routes.cedapCobsListRoute,
    },
    {
      label: 'News',
      route: routes.cedapManageNewsRoute,
    },
    {
      label: 'Statistiche',
      route: routes.cedapStatisticsRoute,
    },
    {
      label: 'Supporto',
      route: routes.cedapSupportRoute,
    },
  ],
};

export const manageNewborn = {
  label: 'Gestione Neonati',
  route: routes.mainMenuManageNewbornRoute,
};

export const metabolic = {
  label: 'Screening Metabolico',
  subMenu: [
    { label: 'Dashboard', route: routes.metabolicDashboardRoute },
    {
      label: 'Gestione neonati',
      route: routes.manageNewbornRoute,
    },
    {
      label: 'Gestione spedizioni',
      route: routes.manageShippingRoute,
    },
    {
      label: 'Archivio referti',
      route: routes.manageReportRoute,
    },
    {
      label: 'Gestione Protocolli',
      route: routes.manageProtocolRoute,
    },
  ],
};

export const auditive = {
  label: 'Screening uditivo',
  subMenu: [
    {
      label: 'Dashboard',
      route: routes.auditiveDashboardRoute,
    },
    {
      label: 'Gestione Pazienti',
      route: routes.auditiveManagePatientsRoute,
    },
    {
      label: 'Gestione neonati',
      route: routes.auditiveManageNewbornRoute,
    },
    {
      label: 'Prenotazioni',
      route: routes.auditiveBookingRoute,
    },
    {
      label: 'Gestione disponibilità',
      route: routes.availabilityRoute,
    },
    {
      label: 'Segnalazioni',
      route: routes.auditiveSignalingRoute,
    },
    {
      label: 'Supporto',
      route: routes.auditiveSupportRoute,
    },
  ],
};

export const ophthalmology = {
  label: 'Screening oftalmologico',
  subMenu: [
    {
      label: 'Dashboard',
      route: routes.ophthalmologyDashboardRoute,
    },
    {
      label: 'Gestione Pazienti',
      route: routes.ophthalmologyManagePatientsRoute,
    },
    {
      label: 'Gestione neonati',
      route: routes.ophthalmologyManageNewbornRoute,
    },
    {
      label: 'Prenotazioni',
      route: routes.ophthalmologyBookingRoute,
    },
    {
      label: 'Gestione disponibilità',
      route: routes.availabilityRouteOft,
    },
    {
      label: 'Segnalazioni',
      route: routes.ophthalmologySignalingRoute,
    },
    // {
    //   label: 'Supporto',
    //   route: routes.auditiveSupportRoute,
    // },
  ],
};

export const regionalSupervisorStatistics = {
  label: 'Statistiche',
  subMenu: [
    {
      label: 'Tipologia parto',
      route: routes.cedapBirthStatisticsRoute,
    },
    {
      label: 'CeDAP',
      route: routes.cedapStatisticsRoute,
    },
    {
      label: 'Preterm/Sottopeso',
      route: routes.facilitiesBirthDataStatistics,
    },
    {
      label: 'PPR',
      route: routes.rppStatisticsRoute,
    },
  ],
};

export const auditiveHsList = {
  label: 'Archivio',
  route: routes.auditiveHsList,
};

export const auditiveFirstLevelStatistics = {
  label: 'Statistiche I Livello',
  route: routes.auditiveFirstLevelStatistics,
};

export const auditiveSecondLevelStatistics = {
  label: 'Statistiche II Livello',
  route: routes.auditiveSecondLevelStatistics,
};

export const manageLhcs = {
  label: 'Gestione ASL',
  route: routes.manageLhcRoute,
};

export const manageFacilities = {
  label: 'Gestione istituzioni',
  route: routes.manageFacilitiesRoute,
};

export const manageWorkgroups = {
  label: 'Gestione strutture',
  route: routes.manageWorkgroupsRoute,
};

export const manageUsers = {
  label: 'Archivio utenti',
  route: routes.manageUsersRoute,
};

export const facilitiesPerformanceStatistics = {
  label: 'Report Perfomance',
  route: routes.facilitiesPerformanceStatisticsRoute,
};

export const manageInvite = {
  label: 'Invita',
  route: routes.manageInviteRoute,
};

export const createSupervisor = {
  label: 'Crea supervisore',
  route: routes.createSupervisorUserRoute,
};

export const manageSupervisors = {
  label: 'Archivio supervisori',
  route: routes.manageSupervisorsRoute,
};

export const mortalityRegistry = {
  label: 'Registro Mortalità',
  route: routes.mortalityRegistry,
};

export const accountsMerge = {
  label: 'Unisci account',
  route: routes.accountsMergeRoute,
};
